import { c as _c } from "react/compiler-runtime";
import { Link, type LinkProps } from '@/components/Link';
import type { CmsLink as CmsLinkData } from '@/services/cms-sdk';
import { urlForCmsLink } from '@/services/cms-sdk/cms/utils/urlForCmsLink';
export interface CmsLinkProps extends Omit<LinkProps, 'href'> {
  link: CmsLinkData;
  href?: LinkProps['href'];
}
export function CmsLink(t0) {
  const $ = _c(17);
  let children;
  let href;
  let link;
  let props;
  let rel;
  let target;
  if ($[0] !== t0) {
    ({
      link,
      href,
      rel,
      target,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = link;
    $[4] = props;
    $[5] = rel;
    $[6] = target;
  } else {
    children = $[1];
    href = $[2];
    link = $[3];
    props = $[4];
    rel = $[5];
    target = $[6];
  }
  let t1;
  if ($[7] !== href || $[8] !== link) {
    t1 = href || urlForCmsLink(link);
    $[7] = href;
    $[8] = link;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const t2 = rel ?? (link.openInNew ? "noreferrer" : undefined);
  const t3 = target ?? (link.openInNew ? "_blank" : undefined);
  const t4 = children || link.title;
  let t5;
  if ($[10] !== link.title || $[11] !== props || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <Link href={t1} rel={t2} target={t3} title={link.title} {...props}>{t4}</Link>;
    $[10] = link.title;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}